import { render, staticRenderFns } from "./carrouselimg.vue?vue&type=template&id=46f5eccc&"
import script from "./carrouselimg.vue?vue&type=script&lang=js&"
export * from "./carrouselimg.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports